<template>
  <main>
    <div id="reservation">
      <section>
        <div class="container mb-3">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-11 text-center">

              <div class="m-title">
                <button v-if="!isLocked" class="btn-history" :disabled="busy" @click="goList">
                  <i class="bi bi-receipt"></i> 결제내역
                </button>
                <h3>NTABI PAY</h3>
                <p class="m-info">현장정산 결제</p>
              </div>

              <!-- 결제정보 -->
              <div class="re-check">
                <p class="title">{{ selectedTitle ? selectedTitle.payTitle : '결제타이틀을 선택하세요' }}</p>
                <table class="table">
                  <tbody>
                    <tr>
                      <th class="name">결제타이틀</th>
                      <td>
                        <select v-model="seqInfo" class="form-select" :disabled="isLocked || busy" @change="selPayInfo(seqInfo)">
                          <option value="">결제타이틀선택</option>
                          <option v-for="pi in tossPayTitle" :key="pi.seqInfo" :value="pi.seqInfo">{{ pi.payTitle }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <th class="name">상품/수량/합계</th>
                      <td>
                        <p v-if="!tossPayDetail.length" class="empty-msg">결제타이틀을 선택하면 상품이 표시됩니다.</p>
                        <div v-for="(pd, idx) in tossPayDetail" :key="idx" class="pay-line">
                          <span class="pay-name">- {{ pd.salePdt }} ({{ getCurrencyFormat(pd.amtPdt) }}원) X</span>
                          <input
                            type="number"
                            v-model.number="pd.qty"
                            min="0"
                            step="1"
                            inputmode="numeric"
                            class="form-control form-control-sm pay-qty"
                            :disabled="isLocked || busy"
                            @blur="fixQty(pd)"
                          >
                          <span class="pay-eq">=</span>
                          <span class="pay-sum">{{ getCurrencyFormat(lineTotal(pd)) }}원</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="name">결제자 성명</th>
                      <td>
                        <input v-model.trim="payerName" type="text" maxlength="40" class="form-control" placeholder="(선택) 결제자 성명" :disabled="isLocked || busy">
                      </td>
                    </tr>
                    <tr>
                      <th class="name">결제자 연락처</th>
                      <td>
                        <input v-model.trim="payCall" type="tel" maxlength="13" class="form-control" placeholder="(선택) 01012345678" :disabled="isLocked || busy">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 청구금액 -->
              <div class="re-count">
                <div class="ro-final">
                  <p>청구금액</p>
                  <p class="sum">{{ getCurrencyFormat(order ? order.payAmt : totalAmt) }}<span class="won">원</span></p>
                  <p v-if="order" class="pay-no">결제번호 {{ order.payNo }}</p>
                </div>
              </div>

              <!-- 1단계: 결제진행 (서버에서 금액 확정 + 결제번호 생성) -->
              <div v-if="!isLocked" class="btn-area">
                <button class="btn cxl col-5 col-lg-3" :disabled="busy" @click="resetAll">초기화</button>
                <button class="btn go col-5 col-lg-3" :disabled="busy || totalAmt <= 0" @click="startPayment">
                  {{ busy ? '처리중...' : '결제진행' }}
                </button>
              </div>

              <!-- 2단계: 결제수단 선택 + 결제 -->
              <div v-show="showWidget">
                <div id="payment-method" class="mt-1"></div>
                <div class="btn-area">
                  <button class="btn cxl col-4 col-lg-2" :disabled="busy" @click="cancelPayment">다시선택</button>
                  <button class="btn btn-primary col-7 col-lg-5" :disabled="busy || !order" @click="doPay">
                    <i class="bi bi-credit-card"></i>
                    {{ busy ? '처리중...' : `${getCurrencyFormat(order ? order.payAmt : 0)}원 결제하기` }}
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import { markRaw } from "vue";
import { loadPaymentWidget, ANONYMOUS } from "@tosspayments/payment-widget-sdk";

// 토스 클라이언트키 — 실서버 이관 시 주석 교체 (app.js의 tossPG 시크릿키와 test/live 짝을 맞출 것)
//const TOSS_CLIENT_KEY = "test_ck_YyZqmkKeP8gG2Klanln8bQRxB9lG";     //For Test(api)
const TOSS_CLIENT_KEY = "live_ck_jZ61JOxRQVEZXa1aoR0rW0X9bAqw";               //For Real(api)
// TODO: 현장정산 상품의 과세여부 확인 (기존 결제와 동일하게 전액 면세로 처리 중)
const TAX_FREE = true;

export default {
  data() {
    return {
      tossPayTitle: [],           // 결제타이틀 목록
      seqInfo: "",                // 선택된 결제타이틀(시퀀스)
      tossPayDetail: [],          // 선택된 타이틀의 상품목록 (+qty)

      payerName: "",              // 결제자 성명(선택)
      payCall: "",                // 결제자 연락처(선택)

      order: null,                // 서버가 확정한 주문 { payNo, payAmt, orderName }
      isLocked: false,            // 결제진행 이후 입력잠금
      showWidget: false,          // 토스 결제위젯 표시
      busy: false,                // 서버요청/결제요청 중복클릭 방지

      paymentWidget: null,
      paymentMethodWidget: null,
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },

    selectedTitle() {
      return this.tossPayTitle.find(t => String(t.seqInfo) === String(this.seqInfo)) || null;
    },

    // 화면 표시용 합계 (실제 결제금액은 서버가 다시 계산한 order.payAmt)
    totalAmt() {
      return this.tossPayDetail.reduce((sum, pd) => sum + this.lineTotal(pd), 0);
    },
  },

  created() {
    if (!this.checkAuth()) return;
    this.getTitle();
  },

  mounted() {
    // 이 페이지에서만 상단 메뉴 숨김
    const userEl = document.getElementById("user");
    if (userEl) userEl.style.display = "none";
    document.querySelectorAll(".nav-item").forEach(el => (el.style.display = "none"));
  },

  beforeUnmount() {
    document.querySelectorAll(".nav-item").forEach(el => (el.style.display = ""));
  },

  methods: {
    /* ---------- 권한 ---------- */
    checkAuth() {
      const grade = this.user?.handlerGrade;
      if (grade === undefined || grade === null || grade >= 5) {
        this.$swal.fire({ title: "로그인 필요", text: "접근권한 확인불가.", icon: "error" });
        this.$router.push({ path: "/b2bLogin" });
        return false;
      }
      return true;
    },

    /* ---------- 조회 ---------- */
    async getTitle() {
      const res = await this.$api("/api/ntabiTossPayTitle", {});
      this.tossPayTitle = Array.isArray(res) ? res : [];
    },

    async selPayInfo(val) {
      this.tossPayDetail = [];
      if (!val) return;

      const res = await this.$api("/api/ntabiTossPayDetail", { param: [val] });

      // 응답 도착 전에 다른 타이틀로 바꾼 경우 무시
      if (String(this.seqInfo) !== String(val)) return;

      this.tossPayDetail = Array.isArray(res) ? res.map(d => ({ ...d, qty: 0 })) : [];
    },

    /* ---------- 수량/금액 ---------- */
    toQty(v) {
      const n = Math.floor(Number(v));
      return Number.isFinite(n) && n > 0 ? n : 0;   // '', null, NaN, 음수 → 0
    },

    fixQty(pd) {
      pd.qty = this.toQty(pd.qty);
    },

    lineTotal(pd) {
      return (Number(pd.amtPdt) || 0) * this.toQty(pd.qty);
    },

    /* ---------- 1단계: 서버에 주문 생성 + 결제위젯 표시 ---------- */
    async startPayment() {
      if (!this.seqInfo) {
        this.$swal.fire("", "결제타이틀을 선택해주세요.", "warning");
        return;
      }
      if (this.totalAmt <= 0) {
        this.$swal.fire("", "상품 수량을 입력해주세요.", "warning");
        return;
      }

      const payCall = this.payCall.replace(/\D/g, "");
      if (payCall && !/^01\d{8,9}$/.test(payCall)) {
        this.$swal.fire("", "연락처 형식을 확인해주세요.", "warning");
        return;
      }

      this.tossPayDetail.forEach(pd => this.fixQty(pd));
      this.busy = true;

      try {
        // 화면은 수량만 보내고, 금액은 서버가 DB 단가로 다시 계산
        const items = this.tossPayDetail
          .map((pd, idx) => ({ idx, salePdt: pd.salePdt, qty: pd.qty }))
          .filter(it => it.qty > 0);

        const res = await this.$api("/api/ntabiTossPay/create", {
          param: [{
            seqInfo: this.seqInfo,
            items,
            payerName: this.payerName,
            payCall,
            insId: this.user.userId,
          }],
        });

        if (!res || !res.ok) {
          this.$swal.fire("", res?.message || "결제요청을 생성하지 못했습니다. 다시 시도해주세요.", "warning");
          return;
        }

        // 화면을 띄운 뒤 단가가 바뀐 경우: 주문을 버리고 최신 단가로 다시 확인하게 함
        if (Number(res.payAmt) !== this.totalAmt) {
          this.order = res;
          await this.abandonOrder("PRICE_CHANGED", "화면금액과 서버금액 불일치");
          await this.selPayInfo(this.seqInfo);
          this.$swal.fire("", "상품 가격이 변경되었습니다. 수량을 다시 입력해주세요.", "warning");
          return;
        }

        this.order = res;
        this.isLocked = true;
        this.showWidget = true;
        await this.$nextTick();
        await this.renderWidget(res.payAmt);
      } catch (e) {
        console.error("[NTABI PAY] 결제창 로드 실패:", e);
        const detail = [e?.code, e?.message].filter(Boolean).join(" / ") || String(e);
        await this.abandonOrder("WIDGET_ERROR", `결제창 로드 실패: ${detail}`.slice(0, 500));
        this.unlock();
        this.$swal.fire({
          icon: "error",
          title: "결제창을 불러오지 못했습니다",
          text: `다시 시도해주세요. (${detail})`,
        });
      } finally {
        this.busy = false;
      }
    },

    async renderWidget(amount) {
      // markRaw: 토스 위젯 객체를 Vue 반응형(Proxy)으로 감싸지 않음
      // (Proxy로 감싸지면 SDK 내부 메서드 호출이 깨질 수 있음)
      if (!this.paymentWidget) {
        const widget = await loadPaymentWidget(TOSS_CLIENT_KEY, ANONYMOUS);
        this.paymentWidget = markRaw(widget);
      }

      // 재진입 시 위젯을 새로 그리지 않고 금액만 갱신
      if (this.paymentMethodWidget) {
        this.paymentMethodWidget.updateAmount(amount);
        return;
      }

      if (!document.querySelector("#payment-method")) {
        throw new Error("결제창 영역(#payment-method)을 찾을 수 없습니다.");
      }

      const methods = this.paymentWidget.renderPaymentMethods(
        "#payment-method",
        { value: Number(amount) },
        { variantKey: "DEFAULT" }
      );
      this.paymentMethodWidget = markRaw(methods);
    },

    /* ---------- 2단계: 토스 결제요청 ---------- */
    async doPay() {
      if (this.busy || !this.order || !this.paymentWidget) return;
      this.busy = true;

      const payCall = this.payCall.replace(/\D/g, "");

      try {
        await this.paymentWidget.requestPayment({
          orderId: this.order.payNo,
          orderName: this.order.orderName,
          successUrl: `${window.location.origin}/ntabiTossPaySuccess`,
          failUrl: `${window.location.origin}/ntabiTossPayFail`,
          ...(this.payerName ? { customerName: this.payerName } : {}),
          ...(payCall ? { customerMobilePhone: payCall } : {}),
          ...(TAX_FREE ? { taxFreeAmount: this.order.payAmt } : {}),
        });
        // 성공/실패 시 각 URL로 이동하므로 이후 코드는 실행되지 않음
      } catch (e) {
        console.error(e);
        if (e?.code === "USER_CANCEL") {
          await this.abandonOrder("USER_CANCEL", "결제창 닫기");
        } else {
          await this.abandonOrder(e?.code || "REQUEST_ERROR", e?.message || "결제요청 오류");
          this.$swal.fire("", e?.message || "결제 요청 중 오류가 발생했습니다.", "error");
        }
        this.unlock();
      } finally {
        this.busy = false;
      }
    },

    /* ---------- 취소/초기화 ---------- */
    // 결제하지 않고 버려진 주문(RP)을 FL로 정리 — 토스는 같은 주문번호 재사용 불가
    async abandonOrder(code, message) {
      if (!this.order) return;
      const payNo = this.order.payNo;
      this.order = null;
      await this.$api("/api/ntabiTossPay/fail", {
        param: [{ orderId: payNo, code, message }],
      });
    },

    async cancelPayment() {
      if (this.busy) return;
      this.busy = true;
      await this.abandonOrder("USER_RESELECT", "다시선택");
      this.unlock();
      this.busy = false;
    },

    unlock() {
      this.isLocked = false;
      this.showWidget = false;
    },

    resetAll() {
      this.unlock();
      this.seqInfo = "";
      this.tossPayDetail = [];
      this.payerName = "";
      this.payCall = "";
    },

    /* ---------- 공통 ---------- */
    goList() {
      this.$router.push({ path: "/ma_NtabiTossPayList" });
    },

    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;500;600;700&display=swap');

#reservation {
  --ci-green:       #86cd53;
  --ci-green-dark:  #6ab53e;
  --charcoal:       #1c1c1c;
  --text-main:      #1c1c1c;
  --text-sub:       #5a5a5a;
  --gray-50:        #fafaf8;
  --gray-100:       #f5f5f5;
  --gray-200:       #e8e8e8;
  --gray-400:       #aaaaaa;
  --radius-sm:      8px;
  --radius-md:      14px;
  --shadow-sm:      0 1px 6px rgba(0,0,0,0.07);

  background: var(--gray-50);
  font-family: 'Noto Sans KR', sans-serif;
  margin: 4rem 0;
}

/* 타이틀 */
#reservation .m-title {
  position: relative;
  background: var(--charcoal);
  border-radius: var(--radius-md);
  padding: 2rem 1.5rem 1.5rem;
  margin-bottom: 1.5rem;
}
#reservation .btn-history {
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(255,255,255,0.1);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 4px 12px;
}
#reservation .btn-history:hover:not(:disabled) {
  background: rgba(255,255,255,0.2);
}
#reservation .m-title h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.3px;
  margin-bottom: 0.3rem;
}
#reservation .m-info {
  font-size: 0.9rem;
  color: var(--ci-green);
  margin: 0;
}

/* 결제정보 */
#reservation .re-check {
  background: #fff;
  border-radius: var(--radius-md);
  border: 1px solid var(--gray-200);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  margin-bottom: 1.2rem;
}
#reservation .re-check .title {
  text-align: left;
  color: #fff;
  background: var(--charcoal);
  font-size: 1.1rem;
  font-weight: 700;
  padding: 0.9rem 1.4rem;
  margin: 0;
  border-bottom: 3px solid var(--ci-green);
}
#reservation .re-check .table {
  vertical-align: middle;
  border: none;
  margin-bottom: 0;
}
#reservation .re-check tr {
  font-size: 0.88rem;
  border-bottom: 1px solid var(--gray-100);
}
#reservation .re-check tr:last-child { border-bottom: none; }
#reservation .re-check .name {
  background: var(--gray-100);
  width: 130px;
  font-weight: 600;
  color: var(--text-sub);
  padding: 0.9rem 1rem;
}
#reservation .re-check td {
  text-align: left;
  padding: 0.9rem 1.4rem;
  color: var(--text-main);
}
#reservation .form-select:focus,
#reservation .form-control:focus {
  border-color: var(--ci-green);
  box-shadow: 0 0 0 3px rgba(134,205,83,0.15);
}
#reservation .re-check ::placeholder {
  color: var(--gray-400);
  font-size: 0.85rem;
}
.empty-msg {
  margin: 0;
  color: var(--gray-400);
  font-size: 0.85rem;
}

/* 상품/수량/합계 줄 */
.pay-line {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
}
.pay-name {
  flex: 1;
  min-width: 0;
}
.pay-qty {
  flex: none;
  width: 70px;
  text-align: right;
}
.pay-eq { flex: none; }
.pay-sum {
  flex: none;
  width: 100px;
  text-align: right;
  font-weight: 600;
}

/* 청구금액 */
#reservation .re-count {
  background: var(--charcoal);
  border-radius: var(--radius-md);
  padding: 1.8rem 1.5rem;
  margin: 1.2rem 0;
}
#reservation .ro-final p {
  font-size: 0.85rem;
  font-weight: 600;
  color: rgba(255,255,255,0.55);
  letter-spacing: 2px;
  margin-bottom: 0.4rem;
}
#reservation .ro-final .sum {
  font-size: 2.8rem;
  font-weight: 900;
  color: var(--ci-green);
  letter-spacing: -1px;
  line-height: 1;
  margin-bottom: 0;
}
#reservation .ro-final .won {
  font-size: 1.2rem;
  font-weight: 400;
  color: rgba(255,255,255,0.4);
  margin-left: 4px;
}
#reservation .ro-final .pay-no {
  margin: 0.8rem 0 0;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  color: rgba(255,255,255,0.4);
}

/* 버튼 */
.btn-area {
  display: flex;
  justify-content: center;
  gap: 0.6rem;
  margin: 1.5rem 0;
}
#reservation .cxl,
#reservation .go {
  border-radius: var(--radius-sm);
  font-size: 1rem;
  font-weight: 700;
  padding: 14px 10px;
  transition: all 0.22s ease;
}
#reservation .cxl {
  background: var(--gray-100);
  color: var(--text-sub);
  border: 1.5px solid var(--gray-200);
}
#reservation .cxl:hover:not(:disabled) { background: var(--gray-200); }
#reservation .go {
  background: var(--charcoal);
  color: #fff;
  border: none;
  box-shadow: 0 4px 14px rgba(0,0,0,0.15);
}
#reservation .go:hover:not(:disabled) {
  background: #333;
  transform: translateY(-2px);
}
#reservation .btn.btn-primary {
  background: var(--ci-green);
  border-color: var(--ci-green);
  color: var(--charcoal);
  font-size: 1.05rem;
  font-weight: 700;
  border-radius: var(--radius-sm);
  box-shadow: 0 4px 16px rgba(134,205,83,0.35);
  padding: 14px 20px;
  transition: all 0.22s ease;
}
#reservation .btn.btn-primary:hover:not(:disabled) {
  background: var(--ci-green-dark);
  border-color: var(--ci-green-dark);
  transform: translateY(-2px);
}
#reservation .btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 모바일 */
@media (max-width: 991px) {
  #reservation .re-check .title { font-size: 1rem; }
  #reservation .re-check .name { font-size: 0.8rem; width: 90px; }
  #reservation .cxl,
  #reservation .go { font-size: 0.9rem; padding: 12px 8px; }
}
@media (max-width: 575px) {
  #reservation .re-count { padding: 1.4rem 1.2rem; }
  #reservation .ro-final .sum { font-size: 2.2rem; }
  .pay-line { flex-wrap: wrap; margin-bottom: 8px; }
  .pay-name { flex: 1 1 100%; }
  .pay-eq { margin-left: auto; }
}
</style>